// Google Analytics Helper Functions

// Track page views
export const trackPageView = (pagePath, pageTitle) => {
  if (window.gtag) {
    window.gtag('config', 'G-532494120', {
      page_path: pagePath,
      page_title: pageTitle,
    });
  }
};

// Track booking submission
export const trackBooking = (service, passengers) => {
  if (window.gtag) {
    window.gtag('event', 'booking_submitted', {
      event_category: 'Reservas',
      event_label: service,
      value: passengers,
    });
  }
};

// Track WhatsApp click
export const trackWhatsAppClick = (location) => {
  if (window.gtag) {
    window.gtag('event', 'whatsapp_click', {
      event_category: 'Contacto',
      event_label: location,
    });
  }
};

// Track destination view
export const trackDestinationView = (destinationName) => {
  if (window.gtag) {
    window.gtag('event', 'destination_view', {
      event_category: 'Destinos',
      event_label: destinationName,
    });
  }
};

// Track form interaction
export const trackFormInteraction = (formField) => {
  if (window.gtag) {
    window.gtag('event', 'form_interaction', {
      event_category: 'Formulário',
      event_label: formField,
    });
  }
};

// Track phone call click
export const trackPhoneClick = () => {
  if (window.gtag) {
    window.gtag('event', 'phone_call', {
      event_category: 'Contacto',
      event_label: 'Telefone',
    });
  }
};

export default {
  trackPageView,
  trackBooking,
  trackWhatsAppClick,
  trackDestinationView,
  trackFormInteraction,
  trackPhoneClick,
};
